(function () {
  'use strict';
  if (window.anomCoffeeAtlas) { window.anomCoffeeAtlas.scan(); return; }
  const resources = new Map();
  const json = url => {
    if (!resources.has(url)) resources.set(url, fetch(url, {signal: AbortSignal.timeout(20000)}).then(r => { if (!r.ok) throw Error('Carte indisponible'); return r.json(); }));
    return resources.get(url);
  };
  let leaflet;
  function loadLeaflet() {
    if (window.L) return Promise.resolve(window.L);
    if (!leaflet) leaflet = new Promise((resolve, reject) => {
      const css = document.createElement('link');
      css.rel = 'stylesheet'; css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      css.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY='; css.crossOrigin = '';
      document.head.append(css);
      const script = document.createElement('script');
      script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      script.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo='; script.crossOrigin = '';
      script.onload = () => resolve(window.L); script.onerror = reject;
      document.head.append(script);
    });
    return leaflet;
  }
  const element = (tag, text, className) => { const e = document.createElement(tag); if (text) e.textContent = text; if (className) e.className = className; return e; };
  const instances = new Map();
  async function start(root) {
    if (root.dataset.atlasReady) return;
    root.dataset.atlasReady = 'loading';
    const status = root.querySelector('[data-atlas-status]');
    const passport = root.querySelector('[data-atlas-passport]');
    try {
      const data = await json(root.dataset.atlasData);
      const box = root.dataset.coffeeAtlas === 'box';
      const keys = box ? data.box : [root.dataset.coffeeAtlas];
      const coffees = keys.map(k => data.coffees[k]);
      if (coffees.some(c => !c)) throw Error('Origine non renseignée');
      const coffee = coffees[0];
      root.style.setProperty('--atlas-ink', box ? '#38190d' : coffee.ink);
      root.style.setProperty('--atlas-paper', box ? '#e1edce' : coffee.paper);
      root.style.setProperty('--atlas-accent', box ? '#ff6333' : coffee.accent);
      const title = root.querySelector('[data-atlas-title]');
      if (!box) {
        title.textContent = 'Cap sur ' + coffee.region + '.';
        root.querySelector('[data-atlas-subtitle]').textContent = coffee.name + ' · ' + coffee.country;
        passport.append(element('div', coffee.name + ' / ' + coffee.country, 'anom-atlas__stamp'));
        passport.append(element('h3', coffee.region));
        const facts = element('dl');
        Object.entries(coffee.facts).forEach(([label, value]) => { const row = element('div'); row.append(element('dt', label), element('dd', value)); facts.append(row); });
        passport.append(element('p', coffee.story, 'anom-atlas__story'), facts);
        if (coffee.notes) {
          passport.append(element('h3', 'En tasse'), element('p', coffee.notes, 'anom-atlas__notes'));
        }
      } else {
        passport.append(element('h3', 'Dans votre Pampa Box'));
      }
      const L = await loadLeaflet();
      if (!root.isConnected) return;
      const host = root.querySelector('[data-atlas-map]');
      host.setAttribute('aria-label', box ? 'Carte du monde des quatre cafés de la Pampa Box' : coffee.country + ' : ' + coffee.region);
      const map = L.map(host, {scrollWheelZoom:false, dragging:true, touchZoom:true, doubleClickZoom:true, keyboard:true, zoomControl:true, minZoom:1, maxZoom:12, maxBounds:[[-85,-180],[85,180]], maxBoundsViscosity:.8});
      const initial = () => { if (box) map.setView([12,-35], host.clientWidth < 500 ? 1 : 2, {animate:false}); else map.setView(coffee.point, coffee.zoom, {animate:false}); };
      initial();
      const tiles = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {maxZoom:12, noWrap:true, bounds:[[-85,-180],[85,180]], attribution:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'}).addTo(map);
      let tileErrors = 0;
      tiles.on('tileerror', () => { if (++tileErrors > 3) status.textContent = 'Le fond de carte est temporairement indisponible. Les repères et les informations restent accessibles.'; });
      json(root.dataset.atlasWorld).then(world => {
        if (!root.isConnected) return;
        L.geoJSON(world, {filter:f => coffees.some(c => c.iso === f.properties.ADM0_A3), style:f => {const c = coffees.find(c => c.iso === f.properties.ADM0_A3);return {color:c.ink,weight:1.5,fillColor:c.paper,fillOpacity:.32};},interactive:false,attribution:'Contours : <a href="https://www.naturalearthdata.com/">Natural Earth</a>'}).addTo(map);
      }).catch(() => { /* Street tiles and exact regional markers remain usable. */ });
      const markers = coffees.map((c, i) => {
        if (c.pin === false) return null;
        let marker;
        if (box) marker = L.circleMarker(c.point, {radius:7,color:'#fff',weight:2,fillColor:c.ink,fillOpacity:1}).addTo(map);
        else {
          const pin = element('div', '', 'anom-atlas__pin'); pin.style.setProperty('--pin-color', c.accent);
          pin.append(element('span', '•'));
          marker = L.marker(c.point, {title:c.name + ' · ' + c.region, icon:L.divIcon({className:'anom-atlas__marker',html:pin,iconSize:[30,36],iconAnchor:[15,36]})}).addTo(map);
        }
        marker.bindTooltip(element('span', (box ? (i + 1) + ' · ' : '') + c.name + ' / ' + c.region), {permanent:!box,direction:'top',offset:[0,box ? -8 : -38]});
        if (root.classList.contains('anom-atlas--compact')) {
          const popup = element('div', '', 'anom-atlas__compact-popup');
          popup.append(element('strong', c.name + ' / ' + c.country), element('p', c.story));
          marker.bindPopup(popup, {maxWidth:240});
        }
        return marker;
      });
      let originButtons = [];
      if (box) {
        const stamp = element('div', coffee.name + ' / ' + coffee.country, 'anom-atlas__stamp');
        const story = element('p', coffee.story, 'anom-atlas__story');
        passport.append(stamp, story);
        const list = element('ol', '', 'anom-atlas__list');
        coffees.forEach((c, i) => {
          const li = element('li'); const button = element('button', '', 'anom-atlas__origin'); button.type = 'button'; button.setAttribute('aria-pressed', 'false');
          const number = element('span', String(i + 1), 'anom-atlas__number'); number.style.setProperty('--origin-color', c.ink);
          const text = element('span'); text.append(element('strong', c.name), element('small', c.country + ' · ' + c.region));
          button.append(number, text); li.append(button); list.append(li);
          button.addEventListener('click', () => {originButtons.forEach(b => b.setAttribute('aria-pressed','false'));button.setAttribute('aria-pressed','true');stamp.textContent=c.name+' / '+c.country;story.textContent=c.story;map.setView(c.point, c.zoom, {animate:!matchMedia('(prefers-reduced-motion:reduce)').matches});markers.forEach(m => m?.closeTooltip());markers[i]?.openTooltip();});
          if (i === 0) button.setAttribute('aria-pressed', 'true');
          originButtons.push(button);
        });
        passport.append(list);
      }
      const resize = new ResizeObserver(() => map.invalidateSize({pan:false}));resize.observe(host);
      instances.set(root, {map,resize});
      root.dataset.atlasReady = 'yes';
      root.dataset.atlasMarkers = String(markers.filter(Boolean).length);
      root.dataset.atlasVersion = data.version;
    } catch (error) {
      root.dataset.atlasReady = 'error';
      status.textContent = 'Carte indisponible pour le moment. Les informations d’origine restent consultables sur cette page.';
    }
  }
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {if(entry.isIntersecting){observer.unobserve(entry.target);start(entry.target);}}),{rootMargin:'250px'});
  function scan() {document.querySelectorAll('[data-coffee-atlas]:not([data-atlas-observed])').forEach(root => {root.dataset.atlasObserved='yes';observer.observe(root);});}
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {instances.forEach((instance,root) => {if(event.target.contains(root)){instance.resize.disconnect();instance.map.remove();instances.delete(root);}});});
  window.anomCoffeeAtlas = {scan};scan();
})();
